import React, { useState, useEffect, useContext } from 'react';
import api from 'api';
import Cookies from 'js-cookie';
import env from 'consts/env';
import { apiInstance, apiInstanceUnauthorized } from 'api/utils';

const DEFAULT_REDIRECT_CALLBACK = () =>
  window.history.replaceState({}, document.title, window.location.pathname);

export const AuthContext = React.createContext({
  isAuthenticated: false,
  user: null,
  loading: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  login: (arg: any) => new Promise(() => null),
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  logout: (arg: any) => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  setCsrfFromHeader: (arg: any) => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  getNewCsrfToken: () => new Promise(() => null),
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  getUser: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  setDesiredPath: (arg: any) => {},
  desiredPath: ''
});
export const useAuth = () => useContext(AuthContext);

interface AuthProviderProps {
  children: any;
  onRedirectCallback: any;
}
const AuthProvider = ({
  children,
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK
}: AuthProviderProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null as any);
  const [loading, setLoading] = useState(true);
  const [desiredPath, setDesiredPath] = useState('');

  const login = (data: any) => api.login(data);

  const setCsrfFromHeader = (res: any) => {
    const token = res.headers['x-csrftoken'];
    apiInstance.defaults.headers.common['X-CSRFToken'] = token;
    apiInstanceUnauthorized.defaults.headers.common['X-CSRFToken'] = token;
  };

  const getNewCsrfToken = (): Promise<any> => {
    return api.getCsrf().then((res: any) => {
      setCsrfFromHeader(res);
      return res;
    });
  };

  const getUser = () => {
    api
      .getUserProfile()
      .then((res: any) => {
        Cookies.set('org', res.data.organization.schema);
        setUser(res.data);
        setCsrfFromHeader(res);
        setIsAuthenticated(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const isRedirectFromIO = window.location.search.includes('io=true');
    if (window.location.search.includes('code=') && !isRedirectFromIO) {
      onRedirectCallback();
    }

    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        loading,
        login,
        getUser,
        desiredPath,
        setDesiredPath,
        setCsrfFromHeader,
        getNewCsrfToken,
        logout: () => {
          api.logout().then(() => {
            setUser(null);
            setIsAuthenticated(false);
            window.location.href = `${env.BASE_URL}/login`;
          });
        }
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
